export default __webpack_public_path__ + "static/media/Remolquede SúperLujo15.25bc0201.png";